<template>
  <ModalSlotted @close="$emit('closed')">
    <header slot="header">
      <h1>{{ user ? 'Editar' : 'Criar' }} usuário</h1>
    </header>
    <div slot="body">
      <form @submit.prevent="submit()" class="flex flex-col px-8 pt-8 pb-4" >
        <div for="email">
          <strong>E-mail/usuário:</strong>
          <input type="email" v-model="form.email" />
        </div>
        <div for="name">
          <strong>Nome:</strong>
          <input type="text" v-model="form.name" />
        </div>
        <div for="isActive">
          <strong>Status:</strong>
          <label for="active">
            <input id="active" type="radio" :value="true" v-model="form.active" />
            Ativo
          </label>
          <label for="inactive" class="ml-4">
            <input id="inactive" type="radio" :value="false" v-model="form.active" />
            Inativo
          </label>
        </div>
        <div>
          <strong>Acessos:</strong>
          <label v-for="role of availableRoles" :key="role.value" class="mr-2" :for="'role-' + role.value" >
            <input type="checkbox" :id="'role-' + role.value" :checked="form.roles.includes(role.value)" v-model="form.roles" :value="role.value" /> {{role.label}}
          </label>
        </div>
        <div for="password" v-if="!user">
          <InputPassword @changed="form.password = $event" />
        </div>
      </form>
    </div>
    <footer slot="footer">
      <button :disabled="saving" @click="$emit('closed')" class="ml-auto btn">Cancelar</button>
      <button :disabled="saving || returnInvalid" @click="submit()" class="ml-2 btn btn--primary">Salvar</button>
    </footer>
  </ModalSlotted>
</template>

<script lang="ts">
import axios from 'axios'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'ModalUser',
  props: {
    user: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState('auth', ['userProfile']),
    returnInvalid () {
      let invalid = false
      for (const field in this.form) {
        if (!this.form[field] && field !== 'active') {
          invalid = true
        }
      }
      return invalid
    }
  },
  data () {
    return {
      form: {
        name: '',
        email: '',
        active: false,
        password: '',
        roles: []
      },
      saving: false,
      showPassword: false,
      availableRoles: [
        {
          value: 'ADMIN',
          label: 'Admin'
        },
        {
          value: 'PARTNER',
          label: 'Parceiro'
        }
      ]
    }
  },
  mounted () {
    if (this.user) {
      for (const field in this.user) {
        if (Object.hasOwnProperty.call(this.form, field)) {
          this.form[field] = this.user[field]
        }
      }
      delete this.form.password
    }
  },
  methods: {
    ...mapMutations('global', ['SET_IS_LOADING']),
    submit () {
      const request = {
        url: process.env.VUE_APP_NEW_API + '/user',
        data: this.form,
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + this.userProfile.token
        }
      }
      this.SET_IS_LOADING(true)
      this.saving = true
      if (this.user) {
        request.method = 'PUT'
        request.url = request.url + '/' + this.user.id
      }
      axios(request).then(
        (res) => {
          this.$emit('closed', true)
        }
      ).catch(
        (err) => {
          console.log(err)
        }
      ).finally(() => {
        this.saving = false
        this.SET_IS_LOADING(false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
form {
  >div {
    @apply mb-4 w-full h-8 flex items-center;
    strong {
      @apply w-32 inline-block text-right mr-2;
    }
  }
  input[type=email], input[type=text], input[type=password] {
    @apply border border-gray-100 border-solid p-2 w-auto;
  }
}
</style>
